<script>
import useSharedSelectData from "@/use/SharedSelectData";

export default {
    name: "SimpleProcessModelFilter",
    props: {
        filter: Object,
    },
    setup() {
        const {boardingChronologies, boardingExecutions, boardingCategories} = useSharedSelectData();

        return {
            boardingChronologies,
            boardingExecutions,
            boardingCategories,
        }
    }
}
</script>

<template>
    <div>
        <v-row dense>
            <v-col cols="12" sm="6" md="2">
                <w-text-field
                    v-model="filter.name"
                    :label="$t('common.name')"
                />
            </v-col>
            <v-col cols="12" sm="6" md="2">
                <w-enum-select
                    v-model="filter.category"
                    :label="$t('boarding.category')"
                    :items="boardingCategories"
                />
            </v-col>
            <v-col cols="12" sm="6" md="2">
                <str-occupation-autocomplete
                    v-model="filter.occupationIds"
                    multiple
                    :label="$t('module.occupations')"
                />
            </v-col>
            <v-col cols="12" sm="6" md="2">
                <w-data-select-autocomplete
                    v-model="filter.socioProfessionalIds"
                    :label="$t('data_select.SOCIO_PROFESSIONAL')"
                    multiple
                    type="SOCIO_PROFESSIONAL"
                />
            </v-col>
            <v-col cols="12" sm="6" md="2">
                <w-enum-select
                    v-model="filter.chronology"
                    :label="$t('boarding.chronology')"
                    :items="boardingChronologies"
                />
            </v-col>
            <v-col cols="12" sm="6" md="2">
                <w-enum-select
                    v-model="filter.execution"
                    :label="$t('boarding.execution')"
                    :items="boardingExecutions"
                />
            </v-col>
        </v-row>
    </div>
</template>